import { TipoCargaDescarga } from "./cargadescarga";
import { CpSatSubTipoRem } from "./requireme";
import { StatusCajaRutaViewDto } from "./statuscajaruta";
export enum StatusPuertaCaja {
    /**El status de caja cerrada implica que no se puede cargar ni descargar mercancía de la misma */
    Cerrada,
    /**La caja abierta indica que si se puede cargar o descargar mercancía de la misma */
    Abierta
}

/**Una caja conectada a un camión */
export interface CajaRuta {
    IdRegistro: number;

    /**Nombre de la caja */
    Nombre: string;

    /**Capacidad de la caja en m3 */
    Capacidad: number;

    /**Indica si la caja esta abierta o cerrada. Note que no se lleva un control histórico de estos cambios de estatus ya que así se confirmo el requerimiento */
    StatusPuerta: StatusPuertaCaja;

    PlacaRemolque: string;

    IdSubtipoRemolque: number | null;

    Peso: number;

}
export interface CajaRutaDTO extends CajaRuta {
    UltimoStatus: StatusCajaRutaViewDto;
    /**Nombre de la sucursal actual o descripcion del viaje en caso de estar en viaje */
    Posicion: string;

    /**True si se le pueden cargar guias a esta caja */
    PuedeCargar: boolean;

    /**True si se le pueden descargar guias a la caja */
    PuedeDescargar: boolean;

    /**Si la caja esta en proceso de carga/descarga, el tipo del proceso de carga */
    TipoCargaDescarga: TipoCargaDescarga | null;

    /**Si la caja esta en proceso de carga/descarga, el id del proceso */
    IdCargaDescarga: number | null;

    SubtipoRemolque: CpSatSubTipoRem;
}





// WEBPACK FOOTER //
// ./app/models/cajaruta.ts